import React, {PureComponent, Fragment} from 'react';
import classnames from 'classnames';
import {Dropdown} from '@homeaway/react-dropdown';
import {FormattedMessage} from 'react-intl';
import {TrackingContext} from '@homeaway/react-event-tracking';
import MultiUnitListWrapper from '../MultiUnitListWrapper/MultiUnitListWrapper';
import {MULTI_UNIT_BUTTON_CLICK} from '../utils/edap';
import './MultiUnitDropdown.less';

const MULTI_UNIT_LABEL = (
    <FormattedMessage id="multipleUnitsButtonLabel" defaultMessage="View all units" />
);

const MULTIPLE_UNITS_DROPDOWN_HEIGHT = 288;

export default class MultiUnitDropdown extends PureComponent {
    state = {
        isOpen: false
    };
    static contextType = TrackingContext;

    onDropdownShow = () => {
        this.context.trigger(MULTI_UNIT_BUTTON_CLICK, this.props.listing);
        this.setState({isOpen: true});
    };

    onDropdownHide = () => {
        this.setState({isOpen: false});
    };

    render() {
        const {isOpen} = this.state;
        const {
            currency,
            inputParams,
            isDatelessSearch,
            isMetric,
            propertyName,
            listing,
            showDesktopView,
            clientLogger
        } = this.props;

        const dropdownClass = classnames('MultiUnit__dropdown', {
            MultiUnitDropdown__Open: isOpen
        });

        return (
            <div className="MultiUnitDropdown" aria-label={propertyName}>
                <Dropdown
                    className={dropdownClass}
                    maxHeight={MULTIPLE_UNITS_DROPDOWN_HEIGHT}
                    label={MULTI_UNIT_LABEL}
                    id="multi-unit-dropdown"
                    dropdownRight
                    open={isOpen}
                    onDropdownShow={this.onDropdownShow}
                    onDropdownHide={this.onDropdownHide}
                >
                    {isOpen && (
                        <Fragment>
                            <MultiUnitListWrapper
                                context="dropdown"
                                currency={currency}
                                inputParams={inputParams}
                                isMetric={isMetric}
                                isDatelessSearch={isDatelessSearch}
                                listing={listing}
                                propertyName={propertyName}
                                onDropdownHide={this.onDropdownHide}
                                isOpen={isOpen}
                                showDesktopView={showDesktopView}
                                clientLogger={clientLogger}
                            />
                        </Fragment>
                    )}
                </Dropdown>
            </div>
        );
    }
}
